import sellingBrands1 from '../images/sellingBrands/1.jpeg'
import sellingBrands2 from '../images/sellingBrands/2.jpeg'
import sellingBrands3 from '../images/sellingBrands/3.jpeg'
import sellingBrands4 from '../images/sellingBrands/4.jpeg'
import sellingBrands5 from '../images/sellingBrands/5.jpeg'
import sellingBrands6 from '../images/sellingBrands/6.jpeg'
import sellingBrands7 from '../images/sellingBrands/7.jpeg'
import sellingBrands8 from '../images/sellingBrands/8.jpeg'

const sellingBrandsData=[{
    image: sellingBrands1
},
{
    image: sellingBrands2
},
{
    image: sellingBrands3
},
{
    image: sellingBrands4
},
{
    image: sellingBrands5
},
{
    image: sellingBrands6
},
{
    image: sellingBrands7
},
{
    image: sellingBrands8
}]
export default sellingBrandsData